import React, {Component} from "react";
import BootstrapTable from "@partseye/react-bootstrap-table-next";

const monthHeader = (full) => {
    const abbr = full.length > 3 ? full.substring(0, 3) : full;
    return <span title={full}>{abbr}</span>;
};

export default class HistoryPopoverContent extends Component {

    constructor(props) {

        super(props);

        this.state = {
            "dataArray": null,
            "partNumber": null,
            "dataError": false
        };

    }

    componentDidMount() {

        this.getHistory(
            this.props.inventorySkuPK,
            this.props.historyType
        );

    }

    getHistory(inventorySkuPK, historyType) {

        switch (historyType) {

            case "suggested":
                this.getPartSuggestHistory(inventorySkuPK);
                break;
            case "ordered":
                this.getPartOrderHistory(inventorySkuPK);
                break;
            case "demand":
                this.getPartDemandHistory(inventorySkuPK);
                break;

        }

    }

    getPartDemandHistory (inventorySkuPK) {

        fetch(`api/PageContent/GetPartDemandHistory/${inventorySkuPK}`).
            then((response) => response.json()).
            then((data) => {

                this.setState({
                    "dataArray": data.slice(
                        0,
                        -1
                    ),
                    "partNumber": data[data.length - 1].partNumber,
                    "dataError": false
                });

            }).
            catch((error) => {

                this.setState({"dataError": true});

            });

    }

    getPartSuggestHistory (inventorySkuPK) {

        fetch(`api/PageContent/GetPartSuggestHistory/${this.props.inventoryPK}/${inventorySkuPK}`).
            then((response) => response.json()).
            then((data) => {

                this.setState({
                    "dataArray": data.suggestHistory || [],
                    "partNumber": data.partNumber,
                    "dataError": false
                });

            }).
            catch((error) => {

                this.setState({"dataError": true});

            });

    }

    getPartOrderHistory (inventorySkuPK) {

        fetch(`api/PageContent/GetPartOrderHistory/${this.props.inventoryPK}/${inventorySkuPK}`).
            then((response) => response.json()).
            then((data) => {

                this.setState({
                    "dataArray": data.orderHistory || [],
                    "partNumber": data.partNumber,
                    "dataError": false
                });

            }).
            catch((error) => {

                this.setState({"dataError": true});

            });

    }

    cleanDemandData(data) {
        return {
            "year": data.year,
            "january": data.months[0].totalLostSales == 0 ? `${data.months[0].totalSales}` : `${data.months[0].totalSales} (${data.months[0].totalLostSales})`,
            "february": data.months[1].totalLostSales == 0 ? `${data.months[1].totalSales}` : `${data.months[1].totalSales} (${data.months[1].totalLostSales})`,
            "march": data.months[2].totalLostSales == 0 ? `${data.months[2].totalSales}` : `${data.months[2].totalSales} (${data.months[2].totalLostSales})`,
            "april": data.months[3].totalLostSales == 0 ? `${data.months[3].totalSales}` : `${data.months[3].totalSales} (${data.months[3].totalLostSales})`,
            "may": data.months[4].totalLostSales == 0 ? `${data.months[4].totalSales}` : `${data.months[4].totalSales} (${data.months[4].totalLostSales})`,
            "june": data.months[5].totalLostSales == 0 ? `${data.months[5].totalSales}` : `${data.months[5].totalSales} (${data.months[5].totalLostSales})`,
            "july": data.months[6].totalLostSales == 0 ? `${data.months[6].totalSales}` : `${data.months[6].totalSales} (${data.months[6].totalLostSales})`,
            "august": data.months[7].totalLostSales == 0 ? `${data.months[7].totalSales}` : `${data.months[7].totalSales} (${data.months[7].totalLostSales})`,
            "september": data.months[8].totalLostSales == 0 ? `${data.months[8].totalSales}` : `${data.months[8].totalSales} (${data.months[8].totalLostSales})`,
            "october": data.months[9].totalLostSales == 0 ? `${data.months[9].totalSales}` : `${data.months[9].totalSales} (${data.months[9].totalLostSales})`,
            "november": data.months[10].totalLostSales == 0 ? `${data.months[10].totalSales}` : `${data.months[10].totalSales} (${data.months[10].totalLostSales})`,
            "december": data.months[11].totalLostSales == 0 ? `${data.months[11].totalSales}` : `${data.months[11].totalSales} (${data.months[11].totalLostSales})`
        };
    }

    getMonthHistoryColumns() {
        return [
            { dataField: "year", text: this.props.pageText.historyPopoverHeaderYear, headerFormatter: () => <span>{this.props.pageText.historyPopoverHeaderYear}</span>, classes: "hp-year-col" },
            { dataField: "january", text: this.props.pageText.historyPopoverHeaderJanuary, headerFormatter: () => monthHeader(this.props.pageText.historyPopoverHeaderJanuary), classes: "hp-month-col" },
            { dataField: "february", text: this.props.pageText.historyPopoverHeaderFebruary, headerFormatter: () => monthHeader(this.props.pageText.historyPopoverHeaderFebruary), classes: "hp-month-col" },
            { dataField: "march", text: this.props.pageText.historyPopoverHeaderMarch, headerFormatter: () => monthHeader(this.props.pageText.historyPopoverHeaderMarch), classes: "hp-month-col" },
            { dataField: "april", text: this.props.pageText.historyPopoverHeaderApril, headerFormatter: () => monthHeader(this.props.pageText.historyPopoverHeaderApril), classes: "hp-month-col" },
            { dataField: "may", text: this.props.pageText.historyPopoverHeaderMay, headerFormatter: () => monthHeader(this.props.pageText.historyPopoverHeaderMay), classes: "hp-month-col" },
            { dataField: "june", text: this.props.pageText.historyPopoverHeaderJune, headerFormatter: () => monthHeader(this.props.pageText.historyPopoverHeaderJune), classes: "hp-month-col" },
            { dataField: "july", text: this.props.pageText.historyPopoverHeaderJuly, headerFormatter: () => monthHeader(this.props.pageText.historyPopoverHeaderJuly), classes: "hp-month-col" },
            { dataField: "august", text: this.props.pageText.historyPopoverHeaderAugust, headerFormatter: () => monthHeader(this.props.pageText.historyPopoverHeaderAugust), classes: "hp-month-col" },
            { dataField: "september", text: this.props.pageText.historyPopoverHeaderSeptember, headerFormatter: () => monthHeader(this.props.pageText.historyPopoverHeaderSeptember), classes: "hp-month-col" },
            { dataField: "october", text: this.props.pageText.historyPopoverHeaderOctober, headerFormatter: () => monthHeader(this.props.pageText.historyPopoverHeaderOctober), classes: "hp-month-col" },
            { dataField: "november", text: this.props.pageText.historyPopoverHeaderNovember, headerFormatter: () => monthHeader(this.props.pageText.historyPopoverHeaderNovember), classes: "hp-month-col" },
            { dataField: "december", text: this.props.pageText.historyPopoverHeaderDecember, headerFormatter: () => monthHeader(this.props.pageText.historyPopoverHeaderDecember), classes: "hp-month-col" }
        ];
    }

    render () {

        let formattedData = [],
            tableColumns,
            defaultSorted;

        if (!this.props.pageText) {

            return <></>;

        }

        if (this.state.dataArray !== null && this.state.dataArray.length > 0) {

            switch (this.props.historyType) {

                case "suggested":
                case "ordered":
                    formattedData = this.state.dataArray;
                    tableColumns = this.getMonthHistoryColumns();
                    defaultSorted = [{ dataField: "year", order: "asc" }];
                    break;
                case "demand":
                    for (let i = 0; i < Math.min(3, this.state.dataArray.length); i++) {

                        formattedData.push(this.cleanDemandData(this.state.dataArray[i]));

                    }
                    tableColumns = this.getMonthHistoryColumns();
                    defaultSorted = [{ dataField: "year", order: "asc" }];
                    break;

            }

        }

        if (this.props.inventorySkuPK === null) {

            return <>
                {this.props.pageText.historyPopoverNoRecords}
                {this.props.historyType === "demand" ? <div>
                    {this.props.pageText.historyPopoverDemandBody}
                </div> : <></>}
            </>;

        } else if (this.state.dataArray === null) {

            return <div>
                {`${this.props.pageText.loading}...`}
            </div>;

        } else if (this.state.dataArray.length === 0) {

            return <>
                {this.props.pageText.historyPopoverNoRecords}
            </>;

        }

        return (
            <>
                {this.state.dataError ? this.props.handleHistoryError()
                    : <>
                        {formattedData.length > 0 ? <BootstrapTable
                            bootstrap4
                            columns={tableColumns}
                            condensed
                            data={formattedData}
                            defaultSorted={defaultSorted}
                            headerClasses="thead-light"
                            keyField="year"
                            striped
                        /> :
                            <span>{this.props.pageText.historyPopoverNoRecords}</span>
                        }
                        {this.props.historyType === "demand" ? <div>
                            {this.props.pageText.historyPopoverDemandBody}
                        </div> : <></>}
                    </>}
            </>

        );


    }

}